






























import Vue from 'vue';
import moment from 'moment';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';

interface LocalState {
  expirationDate: Date | null;
  isUpdating: boolean;
}
export default Vue.extend({
  name: 'ModifyExpirationCustomerOrderModal',
  components: { ValidationObserver },
  props: {
    orderId: {
      type: Number || null,
    },
    expirationDate: {
      type: String,
    },
  },
  computed: {
    minDate() {
      return moment().add(1, 'day').toDate();
    },
  },
  data(): LocalState {
    return {
      expirationDateLocal: this.expirationDate,
      isUpdating: false,
    };
  },
  methods: {
    async onConfirm(): Promise<void> {
      if (this.expirationDateLocal) {
        console.log('this.expirationDateLocal=', this.expirationDateLocal);
        this.isUpdating = true;
        try {
          const payload = {
            id: this.orderId,
            expires_at: moment(this.expirationDateLocal).startOf('day'),
          };
          await this.$store.dispatch('sale/updateExpirationDate', payload);
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t(
              'CUSTOMERS.NOTIFICATIONS.ORDER_EXPIRATION_DATE_SUCCESS'
            ),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to update order expiration date',
            text: errorToMessage(error.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        } finally {
          this.isUpdating = false;
        }
      }
      this.$emit('close');
    },
  },
});
